<script setup lang="ts">
import DeviceMeta from '../DeviceMeta';
import { computed } from 'vue';
import type { PropType } from 'vue';
import type { Value } from '../Default/lib';
import type { MetaProps } from '../DeviceMeta/lib';

const props = defineProps({
  tempValues: {
    type: Array as PropType<Array<Value>>,
    default: undefined,
  },
  meta: {
    type: Object as PropType<MetaProps>,
    required: true,
  },
});

const tempValues = computed(() => props.tempValues);
</script>

<template>
  <div class="w-full text-white font-light font-sans relative">
    <div class="flex items-center justify-around h-[13rem] w-full text-4xl leading-none">
      <div
        v-if="tempValues?.[0]"
        class="flex flex-col items-center text-gray-300 w-16 sm:w-auto"
      >
        <div class="text-xl">
          {{ tempValues[0]?.value }}{{ tempValues[0]?.unit }}
        </div>
        <div class="text-xs text-center">
          {{ tempValues[0]?.name }}
        </div>
      </div>
      <div class="flex flex-col items-center justify-center w-[13rem] h-full border-2 border-solid border-cyan-900 rounded-full p-[2px] box-shadow relative">
        <div class="cyan-circle w-full h-full rounded-full relative p-2 inner-shadow">
          <div class="bg-gray-900 w-full h-full rounded-full flex items-center justify-center p-4">
            <div class="w-full h-full rounded-full light-gray-circle">
              <div
                v-if="tempValues?.[1]"
                class="w-full flex-col h-full rounded-full flex items-center justify-center center-item"
              >
                <div class="text-3xl">
                  {{ tempValues[1]?.value }}{{ tempValues[1]?.unit }}
                </div>
                <div class="text-base">
                  {{ tempValues[1]?.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex flex-col items-center text-center text-gray-600 w-16 sm:w-auto"
      >
        <div
          v-if="tempValues?.[1]"
          class="text-lg"
        >
          5-30{{ tempValues[1]?.unit }}
        </div>
        <div class="text-sm">
          Område
        </div>
      </div>
    </div>

    <DeviceMeta
      v-if="props.meta"
      v-bind="props.meta"
    />
  </div>
</template>

<style lan="scss" scoped>
  .box-shadow {
    box-shadow: 1px -1px 45px -15px rgba(49,163,244,0.75);
    -webkit-box-shadow: 1px -1px 45px -15px rgba(49,163,244,0.75);
    -moz-box-shadow: 1px -1px 45px -15px rgba(49,163,244,0.75);
  }

  .inner-shadow {
    box-shadow: inset 0 1px 3px 0 #213F57, inset 0 3px 6px 0 #3892E3
  }

  .center-item {
    background: rgb(122,115,154);
    background: -moz-linear-gradient(180deg, rgba(122,115,154,1) 0%, rgba(71,68,89,1) 35%, rgba(30,28,37,1) 76%);
    background: -webkit-linear-gradient(180deg, rgba(122,115,154,1) 0%, rgba(71,68,89,1) 35%, rgba(30,28,37,1) 76%);
    background: linear-gradient(180deg, rgba(122,115,154,1) 0%, rgba(71,68,89,1) 35%, rgba(30,28,37,1) 76%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#7a739a",endColorstr="#1e1c25",GradientType=1);
  }

  .light-gray-circle {
    padding: 2px;
    background: rgb(141,137,162);
    background: -moz-linear-gradient(180deg, rgba(141,137,162,1) 0%, rgba(28,26,33,1) 73%);
    background: -webkit-linear-gradient(180deg, rgba(141,137,162,1) 0%, rgba(28,26,33,1) 73%);
    background: linear-gradient(180deg, rgba(141,137,162,1) 0%, rgba(28,26,33,1) 73%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#8d89a2",endColorstr="#1c1a21",GradientType=1);
    box-shadow: 0 5px 17px 3px #000000, 0 -11px 23px 0 #706F80, -1px 18px 15px 19px rgba(0,0,0,0.53);
  }
  .cyan-circle {
    background: rgb(2,249,255);
    background: -moz-linear-gradient(180deg, rgba(2,249,255,1) 25%, rgba(0,62,64,1) 100%);
    background: -webkit-linear-gradient(180deg, rgba(2,249,255,1) 25%, rgba(0,62,64,1) 100%);
    background: linear-gradient(180deg, rgba(2,249,255,1) 25%, rgba(0,62,64,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#02f9ff",endColorstr="#003e40",GradientType=1);
  }
</style>
